import { Button } from "antd";
import { AddTrackingToolFromForm } from "components/Forms/AddTrackingToolFromForm/AddTrackingToolFromForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";

interface AddTrackingToolFromDrawerProps {
    onSubmit: () => void;
}

export const AddTrackingToolFromDrawer: FC<AddTrackingToolFromDrawerProps> = ({ onSubmit }) => {
    const { t } = usePaldockTranslation("drawers.add-tracking-tool-from");
    const { t: tC } = usePaldockTranslation("common");
    const id = DrawerId.AddTrackingToolFrom;
    const formId = FormId.AddTrackingToolFromForm;
    const drawerUtils = useDrawer();

    const handleSubmit = () => {
        drawerUtils.hide(id);
        onSubmit();
    };

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("title")} />}
            extraButtons={
                <Button size={"large"} htmlType="submit" type={"primary"} form={formId}>
                    {tC("save")}
                </Button>
            }
        >
            <AddTrackingToolFromForm onSubmit={handleSubmit} formId={formId} />
        </Drawer>
    );
};
